import React, { Component } from 'react';
import { formDataSchema } from '../../../../schema/add-user';
import { doctorForm } from './../../../../schema/doctors';
import Tableantd from '../../../../components/FormComponent/table/antd';
import { cousellingStationSchema } from './../../../../schema/add-cousellingStation';
import { editCousellingStationSchema } from './../../../../schema/edit-cousellingStation';
import Datepicker from '../../../../components/FormComponent/Date';
import Select2 from '../../../../components/FormComponent/select2';
import Select2multiple from '../../../../components/FormComponent/select2/updatemultiple';
import { editPrivilegeSchema } from './../../../../schema/edit-privilege';
import { privilegeTableSchema } from './../../../../schema/privilege-table';
import Inputlayer from '../../../../components/FormComponent/Input';
// import Inputlayer from '../../../../components/version2form_component/input/index'
import networkList from './../../../../constants/networkList';
import postService from './../../../../services/httpService';
import Storage from '../../../../services/local-store';
import userTrackService from './../../../../services/usertrack-service';

import { Modal, Spin, Switch } from 'antd';

const $ = require('jquery');
const {homepage} = networkList;
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class Add_User extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            formData: [],
            addText: '',
            showPrevilages: false,
            pre_link: '',
            units: [],
            date: new Date(),
            previlages_message_show: false,
            privilegeTableSchema: JSON.parse(JSON.stringify(privilegeTableSchema['feilds'])),
            privilageSelectID: [],
            thead:[],
            tbody:[],
            allUnitPriviage:[],
            previesUnitPriviegeTime:[],
            priviageErrorMessage:false
        }
    }
    showModal = () => {
        this.setState({
            visible: true
        })
    }
    componentDidMount() {
        window.scrollTo(0,0);
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const unid = params.get('unid');
        let { slug } = this.props.match.params;
        const { getUserDetailsById, getDoctorIdDetails, getCounsellingStationDetails, stationTvDisplay, getPrivilegesbyid } = networkList;
        let formSchema = Object.assign({}, formDataSchema);
        const { privilegeTableSchema, privilageSelectID } = this.state;
        let tableHead = [];
        let userData = localStorage.getItem('user_data');
        if (userData !== undefined && userData !== null && userData !== '') {
            userData = JSON.parse(userData);
        }
      let roleid=  userData ? userData['roleid'] :null;

        switch (slug) {
            case 'add-user':
                formSchema['feilds'].map((feild, key) => {
                    formSchema['feilds'][key]['value'] = null;
                    formSchema['feilds'][key]['disable'] = false;
                    formSchema['feilds'][key]['valid'] = false;
                    formSchema['feilds'][key]['errors'] = [];
                    if (feild['name'] === 'counsellor_type') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    if (feild['name'] === 'mapping_unit') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    if (feild['name'] === 'payment1') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    if (feild['name'] === 'nurse_station') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    if (feild['name'] === 'mapping_conselling_station') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    if (feild['name'] === 'mapping_doctor') {
                        feild['visible'] = false;
                        feild['value'] = [];
                    }
                    delete formSchema['feilds'][key]['text'];

                })
                privilegeTableSchema[0]['visible'] = false;
                this.setState({ addText: 'Add New User', buttonText: 'Save User', 'formData': formSchema['feilds'], privilegeTableSchema });
                break;
            case 'edit-user':
                tableHead = [
                    {
                        "key": 's_no',
                        'text': 's.no'
                    },{
                        "key": 'doctor_name',
                        'text': 'Doctor Name',
                    },{
                        "key": 'doctor_id',
                        'text': 'Doctor ID',
                    },
                    //  {
                    //     "key": 'unitname',
                    //     'text': 'unit',
                    // },
                     {
                        "key": 'fk_department_id',
                        'text': 'Department',
                    },
                    
                  ]
                privilegeTableSchema[0]['visible'] = false;
                privilegeTableSchema.map((data, secKey) => {
                    data['Specification']['table_body'].map((table_body, table_key) => {
                        table_body['feilds'].map((feilds, key) => {
                            if(key===0){
                                if (feilds.name === "privilege_name") {
                                    privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = null
                                    privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = null
                                }
                                if (feilds.name === "action") {
                                    privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';

                                }
                            }
                            else {
                                privilegeTableSchema[secKey].Specification.table_body.splice(1, table_body['feilds'].length)
                                }
                        })
                    })
                })
                this.setState((state) => ({ addText: 'Edit User', 'rid': rid, 'formData': formSchema['feilds'],privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema)),thead:tableHead }), () => {
                    postService(getUserDetailsById, 'POST', { "data": { "id": rid } }).then(res => {
                        // console.log('response',res.data[0]);
                        if (res.status) {
                            // this.setState((state) => ({ tbody: res.data[0], loadding: false }));

                            formSchema['feilds'].map((feild, key) => {
                                if (feild['name'] === 'name') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['username'];
                                }
                                if (feild['name'] === 'gender') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['gender'];
                                    formSchema['feilds'][key]['text'] = res.data[0]['gender'];
                                }
                                if (feild['name'] === 'dob') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['dob'];
                                    formSchema['feilds'][key]['text'] = res.data[0]['dob'];
                                }
                                if (feild['name'] === 'phonenumber') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['phone_number'];
                                }
                                if (feild['name'] === 'unit') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['unitid'];
                                    formSchema['feilds'][key]['text'] = res.data[0]['unitname'];
                                }
                                if (feild['name'] === 'role_id') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['roleid'];
                                    formSchema['feilds'][key]['text'] = res.data[0]['rolename'];
                                    const { getPrivileges } = networkList;
                                    let resPrevilagearray = [];
                                    let previlageArray = [];
                                    if (res.data[0]["privileges"].length > 0) {
                                        if (res.data[0]['roleid'] === 'RL_HjPW') {
                                            let { formData } = this.state;
                                            privilegeTableSchema.map((data, secKey) => {
                                                data['Specification']['table_body'].map((table_body, table_key) => {
                                                    table_body['feilds'].map((feilds, key) => {
                                                        if(key===0){
                                                            if (feilds.name === "privilege_name") {
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = null
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = null
                                                            }
                                                            if (feilds.name === "action") {
                                                                privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['element'] = 'text';
                        
                                                            }
                                                        }
                                                        else {
                                                            privilegeTableSchema[secKey].Specification.table_body.splice(1, data['Specification']['table_body'].length)
                                                            }
                                                    })
                                                })
                                            })
                                            this.setState({privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema))})
                                            privilegeTableSchema.map((data, secKey) => {
                                                if (secKey === 0) {
                                                    res.data[0]["privileges"].map((privileges, privilege_key) => {
                                                      
                                                        if (privilege_key === 0) {
                                                            data['Specification']['table_body'].map((table_body, table_key) => {
                                                                table_body['feilds'].map((feilds, key) => {
                                                                    if (feilds.name === "privilege_name") {
                                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = privileges['privilege_id']
                                                                        privilegeTableSchema[secKey].Specification.table_body[table_key].feilds[key]['text'] = privileges['privilege_name']
                                                                    }

                                                                })
                                                            })
                                                        }
                                                        else {
                                                            let obj = {
                                                                "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? (JSON.parse(JSON.stringify(data['Specification']['add_more_feilds']))) : [],
                                                                id: privilege_key + 1,
                                                                input_feild: [],
                                                                text: "Highend",
                                                                'key_word': 'add_more',
                                                                type: "text"
                                                            }

                                                            obj['feilds'].map((feild, key) => {
                                                                if (feild.name === "privilege_name") {
                                                                    obj['feilds'][key]['value'] = privileges['privilege_id'];
                                                                    obj['feilds'][key]['text'] = privileges['privilege_name'];
                                                                }
                                                            })
                                                            data['Specification']['table_body'].push(obj);
                                                        }
                                                        let payload = {
                                                            'id': privilege_key + 1,
                                                            'value': privileges['privilege_id']
                                                        }
                                                        privilageSelectID.push(payload)
                                                    })
                                                }
                                            })
                                            privilegeTableSchema.map((subTable, key) => {
                                                let table_body = subTable.Specification.table_body;
                                                table_body.map((feild, table_key) => {
                                                    let row = feild.feilds;
                                                    row.map((sub_feild, sub_table_key) => {
                                                        privilegeTableSchema[key].Specification.add_more_title = 'Add Privilege';
                                                        let privileagetotal=localStorage.getItem('privilege_total')
                                                    if(privileagetotal===privilageSelectID.length){
                                                        privilegeTableSchema[key].Specification.add_more = true;
                                                        privilegeTableSchema[key].Specification.add_more  = 'text'; 
                                                    }else{
                                                        privilegeTableSchema[key].Specification.add_more = true;
                                                    }
                                                    })
                                                })
                                            })

                                            formData.map((feild, key) => {
                                                if (feild['id'] > 15) {
                                                    delete formData[key];
                                                }
                                                if (formData[key]['name'] === 'counsellor_type') {
                                                    formData[key]['visible'] = true
                                                }


                                            })
                                            privilegeTableSchema[0]['visible'] = true
                                            this.setState((state) => ({
                                                'formData': formData,
                                                showPrevilages: false,
                                                privilegeTableSchema, privilageSelectID
                                            }), () => {
                                            })


                                        }
                                    }

                                }
                                if(res.data[0]['roleid'] === 'RL_HjPW'){
                                    if (feild['name'] === 'counsellor_type') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['counsellor_types'];
                                        formSchema['feilds'][key]['disable'] = false;
                                    }
                                }else{
                                    if (feild['name'] === 'counsellor_type') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['counsellor_types'];
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                }
                                if(res.data[0]['roleid'] === 'RL_UYUR'){
                                    if (feild['name'] === 'nurse_station') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['nurse_station']?res.data[0]['nurse_station']:null;
                                        formSchema['feilds'][key]['visible'] = true;
                                    }
                                }else{
                                    if (feild['name'] === 'nurse_station') {
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                }
                                if (feild['name'] === 'counselling_stations') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['counselling_station_id'];
                                    formSchema['feilds'][key]['text'] = res.data[0]['counselling_station_name'];
                                    formSchema['feilds'][key]['disable'] = false;
                                }
                                if ((roleid === 'RL_ayhy' || (roleid ==='RL_ijmN' || roleid ==='RL_tSU5')) && (res.data[0]['roleid']==='RL_ijmN' || res.data[0]['roleid']==='RL_tSU5')) {
                                    if (res.data[0]['mapping_unit'].length > 0) {
                                        if (feild['name'] === 'mapping_unit') {
                                            formSchema['feilds'][key]['value'] = res.data[0]['mapping_unit'];
                                            formSchema['feilds'][key]['visible'] = true;
                                        }
                                    } else {
                                        if (feild['name'] === 'mapping_unit') {
                                            formSchema['feilds'][key]['visible'] = true;
                                        }
                                    }
                                }else{
                                    if (feild['name'] === 'mapping_unit') {
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                }
                                if (feild['name'] === 'user_id') {
                                    formSchema['feilds'][key]['value'] = res.data[0]['userid'];
                                    formSchema['feilds'][key]['disable'] = true;
                                }
                                if (feild['name'] === 'password') {
                                    // formSchema['feilds'][key]['value'] = res.data[0]['password'];
                                    formSchema['feilds'][key]['value'] = '******';
                                    formSchema['feilds'][key]['disable'] =roleid==='RL_ayhy'?false: true;
                                }
                                if(res.data[0]['roleid'] === 'RL_HjPW'){
                                    if (feild['name'] === 'mapping_conselling_station') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['counselling_stations'];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = true;
                                    }
                                    if (feild['name'] === 'payment1') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['user_payer_type'] === null ? 'All': res.data[0]['user_payer_type'];
                                        formSchema['feilds'][key]['text'] = res.data[0]['user_payer_type'] === null ? 'All': res.data[0]['user_payer_type'];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = true;
                                    }
                                }else{
                                    if (feild['name'] === 'mapping_conselling_station') {
                                        formSchema['feilds'][key]['value'] = [];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                    if (feild['name'] === 'payment1') {
                                        formSchema['feilds'][key]['value'] = [];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                }
                                if(res.data[0]['roleid'] === 'RL_aChP'){
                                    if (feild['name'] === 'mapping_doctor') {
                                        formSchema['feilds'][key]['value'] = res.data[0]['mapping_doctor_secrect'];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = true;
                                    }
                                }else{
                                    if (feild['name'] === 'mapping_doctor') {
                                        formSchema['feilds'][key]['value'] = [];
                                        formSchema['feilds'][key]['disable'] = false;
                                        formSchema['feilds'][key]['visible'] = false;
                                    }
                                }
                                // console.log('name',feild['name'] === uKey,feild['name'],uKey,res.data[0][uKey]);


                            })
                            this.setState({ addText: 'Edit User', buttonText: 'Update', 'formData': formSchema['feilds'],tbody: res.data[0].mapping_doctor });
                        }
                    });
                });


                break;
            case 'add-doctor':

                privilegeTableSchema[0]['visible'] = false;
                doctorForm['feilds'].map((feild, key) => {
                    doctorForm['feilds'][key]['value'] = null;
                    doctorForm['feilds'][key]['disable'] = false;
                    doctorForm['feilds'][key]['valid'] = false;
                    doctorForm['feilds'][key]['errors'] = [];
                    delete doctorForm['feilds'][key]['text'];

                })
                this.setState({ addText: 'Add New Doctor', buttonText: 'Save Doctor', 'formData': doctorForm['feilds'],privilegeTableSchema });
                break;
            case 'edit-doctor':
             
                privilegeTableSchema[0]['visible'] = false;
                this.setState((state) => ({ addText: 'Edit Doctor', 'formData': doctorForm['feilds'] }), () => {
                    postService(getDoctorIdDetails, 'POST', { "ID": rid, "unit_id": unid }).then(res => {
                        if (res.status) {

                            doctorForm['feilds'].map((feild, key) => {
                                if (feild['name'] === 'name') {
                                    doctorForm['feilds'][key]['value'] = res.data[0]['name'];
                                    doctorForm['feilds'][key]['disable'] = true;
                                }
                                if (feild['name'] === 'doctorid') {
                                    doctorForm['feilds'][key]['value'] = rid;
                                }
                                if (feild['name'] === 'phonenumber') {
                                    doctorForm['feilds'][key]['value'] = res.data[0]['phone_number'];
                                    doctorForm['feilds'][key]['disable'] = false;
                                }
                                if (feild['name'] === 'speciality_id') {
                                    doctorForm['feilds'][key]['value'] = res.data[0]['speciality_id'];
                                    doctorForm['feilds'][key]['text'] = res.data[0]['speciality_name'];
                                    doctorForm['feilds'][key]['disable'] = true;
                                }


                                if (feild['name'] === 'unit_id') {
                                    doctorForm['feilds'][key]['value'] = res.data[0]['fk_unit_id'];
                                    doctorForm['feilds'][key]['text'] = res.data[0]['unitname'];
                                    doctorForm['feilds'][key]['disable'] = true;
                                }

                                if (feild['name'] === 'department_id') {
                                    // doctorForm['feilds'][key]['value'] = res.data[0]['department_id'];
                                    doctorForm['feilds'][key]['text'] = res.data[0]['departmentname'];
                                    doctorForm['feilds'][key]['value'] = res.data[0]['departmentname'];
                                    doctorForm['feilds'][key]['disable'] = true;
                                }

                                if (feild['name'] === 'counsellor_id') {
                                    let newData = []
                                    res.data[0]['counsellors'].map((userData, roomKey) => {
                                        newData.push({
                                            'id': userData['counsellor_id'],
                                            'name': userData['counsellor_name']
                                        })
                                    })
                                    doctorForm['feilds'][key]['value'] = res.data[0]['counsellors'];
                                    // doctorForm['feilds'][key]['text'] = res.data[0]['counsellor_name'];
                                }
                                // if (feild['name'] === 'send_whatsapp_sms') {
                                //     doctorForm['feilds'][key]['value'] = res.data[0]['send_whatsapp_sms'];
                                //     doctorForm['feilds'][key]['text'] = res.data[0]['send_whatsapp_sms'];
                                //     doctorForm['feilds'][key]['disable'] = false;
                                // }
                                if (feild['name'] === 'send_whatsapp_sms') {
                                    if (res.data[0]['send_whatsapp_sms'] == 1) {
                                        doctorForm['feilds'][key]['value'] = '1';
                                        doctorForm['feilds'][key]['text'] = 'Yes';
                                    } else {
                                        doctorForm['feilds'][key]['value'] = '0';
                                        doctorForm['feilds'][key]['text'] = 'No';
                                    }
                                   
                                        doctorForm['feilds'][key]['disable'] = false;
                                    
                                }
                                if (feild['name'] === 'care_management') {
                                    if (res.data[0]['care_management'] == '1') {
                                        doctorForm['feilds'][key]['value'] = '1';
                                        doctorForm['feilds'][key]['text'] = 'Medical';
                                    } else if (res.data[0]['care_management'] == '2') {
                                        doctorForm['feilds'][key]['value'] = '2';
                                        doctorForm['feilds'][key]['text'] = 'Surgical';
                                    }else if (res.data[0]['care_management'] == '3') {
                                        doctorForm['feilds'][key]['value'] = '3';
                                        doctorForm['feilds'][key]['text'] = 'Medical,Surgical';
                                    }
                                    else {
                                        doctorForm['feilds'][key]['value'] = '';
                                        doctorForm['feilds'][key]['text'] = '';
                                    }
                                   
                                        doctorForm['feilds'][key]['disable'] = true;
                                    
                                }
                                // console.log('name',feild['name'] === uKey,feild['name'],uKey,res.data[0][uKey]);


                            })

                            this.setState({ addText: 'Edit Doctor', buttonText: 'Update', 'formData': doctorForm['feilds'],privilegeTableSchema });
                        }
                    })
                });
                break;
            case 'add-counselling-stations':
                privilegeTableSchema[0]['visible'] = false;
                cousellingStationSchema['feilds'].map((feild, key) => {
                    cousellingStationSchema['feilds'][key]['value'] = null;
                    cousellingStationSchema['feilds'][key]['disable'] = false;
                    cousellingStationSchema['feilds'][key]['valid'] = false;
                    cousellingStationSchema['feilds'][key]['errors'] = [];
                    delete cousellingStationSchema['feilds'][key]['text'];

                })
                this.setState({ addText: 'Add Counselling Station', buttonText: 'Save', 'formData': cousellingStationSchema['feilds'],privilegeTableSchema });
                break;
            case 'edit-counselling-stations':
                privilegeTableSchema[0]['visible'] = false;
                this.setState((state) => ({ addText: 'Edit Counselling Station', 'formData': doctorForm['feilds'],privilegeTableSchema }), () => {
                    const Userlogobj = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Edit Counselling Station- Request",
                            "date": new Date(),
                            "meta": { "ID": rid }
                        }
                    }
                    userTrackService(Userlogobj);
                    postService(getCounsellingStationDetails, 'POST', { "id": parseInt(rid) }).then(res => {
                        const Userlogobjres = {
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Edit Counselling Station- Response",
                                "date": new Date(),
                                "meta": res
                            }
                        }
                        userTrackService(Userlogobjres);
                        if (res.status) {
                            editCousellingStationSchema['feilds'].map((feild, key) => {
                                if (feild['name'] === 'unitname') {
                                    editCousellingStationSchema['feilds'][key]['value'] = res.data[0]['unitname'];
                                }
                                if (feild['name'] === 'counselling_station_name') {
                                    editCousellingStationSchema['feilds'][key]['value'] = res.data[0]['counselling_station_name'];
                                }
                                if (feild['name'] === 'id') {
                                    editCousellingStationSchema['feilds'][key]['value'] = res.data[0]['id'];
                                }
                                if (feild['name'] === 'unit_id') {
                                    editCousellingStationSchema['feilds'][key]['value'] = res.data[0]['unit_id'];
                                }
                                if (feild['name'] === 'tv_url') {
                                    editCousellingStationSchema['feilds'][key]['value'] = `${hostname + '/' + stationTvDisplay}` + res.data[0]['tv_url'];
                                    this.setState({ get_tv_url: res.data[0]['tv_url'] })
                                }
                                if (feild['name'] === 'cabin_count') {
                                    editCousellingStationSchema['feilds'][key]['value'] = res.data[0]['cabin_count'];
                                }
                            })

                            this.setState({ addText: 'Edit Counselling Station', buttonText: 'Update', 'formData': editCousellingStationSchema['feilds'] });
                        }
                    })
                });
                break;
            case 'edit-privilege':
                privilegeTableSchema[0]['visible'] = false;
                this.setState((state) => ({ addText: 'Edit Privilege', buttonText: 'Update', 'formData': editPrivilegeSchema['feilds'],privilegeTableSchema }), () => {
                    const Userlogobj = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Edit Privilege - Request",
                            "date": new Date(),
                            "meta": { "ID": rid }
                        }
                    }
                    userTrackService(Userlogobj);
                    postService(getPrivilegesbyid, 'POST', { 'id': parseInt(rid) }).then(res => {
                        const Userlogobjres = {
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Edit Privilege - Response",
                                "date": new Date(),
                                "meta": res
                            }
                        }
                        userTrackService(Userlogobjres);
                        if (res.status) {
                            console.log('resStatus', res)
                            editPrivilegeSchema['feilds'].map((feild, key) => {
                                if (feild['name'] === 'privilege_name') {
                                    editPrivilegeSchema['feilds'][key]['value'] = res.data["privileges"][0]['privilege_name'];
                                    editPrivilegeSchema['feilds'][key]['disable'] = true;
                                }
                                if (feild['name'] === 'emergency') {

                                    if (res.data["privileges"][0]['is_emergency'] == 1) {
                                        editPrivilegeSchema['feilds'][key]['value'] = '1';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                                    } else {
                                        editPrivilegeSchema['feilds'][key]['value'] = '0';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'No';
                                    }
                                    if (Storage.get('roleid') !== '"RL_ayhy"') {
                                        editPrivilegeSchema['feilds'][key]['disable'] = true;
                                    }
                                }
                                if (feild['name'] === 'form_type') {
                                    editPrivilegeSchema['feilds'][key]['value'] = res.data["privileges"][0]['form_type_id'];
                                    editPrivilegeSchema['feilds'][key]['text'] = res.data["privileges"][0]['form_type_name'];
                                    if (Storage.get('roleid') !== '"RL_ayhy"') {
                                        editPrivilegeSchema['feilds'][key]['disable'] = true;
                                    }
                                }
                                if (feild['name'] === 'time_duration') {
                                    editPrivilegeSchema['feilds'][key]['value'] = res.data["units"][0]['time_duration'];
                                    editPrivilegeSchema['feilds'][key]['text'] = res.data["units"][0]['time_duration'];
                                }
                                if (feild['name'] === 'unitname') {
                                    this.setState({ units: res.data['units'] })
                                    console.log(res.data['units'])
                                }
                                if (feild['name'] === 'admission') {
                                    if (res.data["privileges"][0]['only_admission'] == 1) {
                                        editPrivilegeSchema['feilds'][key]['value'] = '1';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                                    } else {
                                        editPrivilegeSchema['feilds'][key]['value'] = '0';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'No';
                                    }
                                    if (Storage.get('roleid') !== '"RL_ayhy"') {
                                        editPrivilegeSchema['feilds'][key]['disable'] = false;
                                    }
                                }
                                if (feild['name'] === 'whatsapp') {
                                    if (res.data["privileges"][0]['send_whatsapp_sms'] == 1) {
                                        editPrivilegeSchema['feilds'][key]['value'] = '1';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                                    } else {
                                        editPrivilegeSchema['feilds'][key]['value'] = '0';
                                        editPrivilegeSchema['feilds'][key]['text'] = 'No';
                                    }
                                    if (Storage.get('roleid') !== '"RL_ayhy"') {
                                        editPrivilegeSchema['feilds'][key]['disable'] = false;
                                    }
                                }
                            })
                            this.setState({ addText: 'Edit Privilege', buttonText: 'Update', 'formData': editPrivilegeSchema['feilds'],previesUnitPriviegeTime:res.data["units"]});
                            console.log('Priviledge', this.state);
                            // alert('Data inserted');
                            // console.log('getPrivilegesbyid', res)
                            // this.setState((state) => ({ btnloading: false }));
                        }
                    })
                });
                break;
            default:
                break;
        }
    }

    componentWillUnmount() {
        this.setState({
            visible: false,
            formData: [],
            showPrevilages: false,
            privilegeTableSchema: [],
            privilageSelectID: []
        });
    }
    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }

    handleChange(ele) {
        console.log(ele);
        const { checkDuplicateUser, getPrivileges } = networkList;
        const { slug } = this.props.match.params;
        let { privilegeTableSchema, privilageSelectID } = this.state;
        console.log('SLUG',slug);
        let previlageArray = [];
        if (slug === 'add-user' || slug === 'edit-user') {

            if (ele['name'] === 'unit') {
                this.state.changedObj = ele;
            }
            if (ele['name'] === 'privilege_name') {
                const { id, value } = ele;
                if (value !== '' && value !== undefined && value !== null) {
                    const index = privilageSelectID.map(item => item.id).indexOf(id);
                    if (index > -1) {
                        privilageSelectID[index].value = value;
                    } else {
                        const obj = { id, value };
                        privilageSelectID.push(obj)
                    }
                    this.setState({ privilageSelectID });
                }
                let privileagetotal=localStorage.getItem('privilege_total')
                if(privileagetotal==2){
                    privilegeTableSchema[0]['Specification']['add_more'] = false;
                }else{
                    privilegeTableSchema[0]['Specification']['add_more'] = true;
                }
                this.setState((state) => ({privilegeTableSchema:JSON.parse(JSON.stringify(privilegeTableSchema)) }));

            }
            

            let { formData } = this.state;
            formData
                .map((data, key) => {

                    if (data['name'] === ele['name']) {
                        data['value'] = ele.value;
                        data['text']=ele.value;
                        data['valid'] = true;
                        if(ele['name'] === 'name' || ele['name']==='user_id') {
                        // var    regex = /^[a-zA-Z ]*$/
                        //     if(regex.test(ele.value)){
                        //         data['value'] = ele.value;
                        //         data['text']=ele.value;
                        //     }else{
                        //         data['value']=null
                        //         data['text']=null
                        //     }
                            // data.visible =false
                        }
                        formData[key] = data;
                        if (data['name'] === 'role_id') {
                            if (ele['value'] === 'RL_HjPW') {
                                // let { formData } = this.state;
                                formData.map((feild, key) => {
                                    if (feild['id'] > 15) {
                                        delete formData[key];
                                    }
                                    if (formData[key]['name'] === 'counsellor_type') {
                                        formData[key]['visible'] = true
                                        privilegeTableSchema[0]['visible'] = true;
                                        let privileagetotal=localStorage.getItem('privilege_total')
                                        if(privileagetotal===privilageSelectID.length){
                                            privilegeTableSchema[0]['Specification']['add_more'] = false;
                                        }else{
                                            privilegeTableSchema[0]['Specification']['add_more'] = true;
                                        }
                                        privilegeTableSchema[0]['Specification']['add_more_title'] = 'Add Privilege';
                                        this.setState({ privilegeTableSchema: JSON.parse(JSON.stringify(privilegeTableSchema)) });
                                    }
                                    if (formData[key]['name'] === 'mapping_conselling_station') {
                                        formData[key]['visible'] = true
                                    }
                                    if (formData[key]['name'] === 'payment1') {
                                        formData[key]['visible'] = true
                                    }
                                })

                                this.setState((state) => ({
                                    'formData': formData,
                                    showPrevilages: false
                                }), () => {

                                    
                                })
                            } else {
                                let { formData } = this.state;

                                formData.map((feild, key) => {
                                    if (feild['id'] > 15) {
                                        //formData.splice(key, 1);
                                        delete formData[key];
                                    }
                                    if (feild['name'] === 'counsellor_type' || feild['name'] === 'mapping_conselling_station') {
                                        feild['visible'] = false;
                                        feild['value'] = [];
                                    }
                                   
                                })
                                privilegeTableSchema[0]['visible'] = false;
                                this.setState({ privilegeTableSchema: privilegeTableSchema });
                                this.setState((state) => ({
                                    'formData': formData,
                                    showPrevilages: false
                                }))
                            }

                            if (ele['value'] === 'RL_HjPW') {
                                formData.map((feild, key) => {
                                    if (formData[key]['name'] === 'payment1') {
                                        formData[key]['visible'] = true
                                    }
                                })
                                this.setState((state) => ({ 'formData': formData }), () => { })
                            } else {
                                formData.map((feild, key) => {
                                    if (feild['name'] === 'payment1') {
                                        feild['visible'] = false;
                                        feild['value'] = [];
                                    }
                                })
                                this.setState((state) => ({ 'formData': formData }), () => { })
                            }
                            let user_data = JSON.parse(localStorage.getItem('user_data'));
                            const roleid = user_data ? user_data.roleid : '';
                            if (roleid === "RL_ayhy" || (roleid ==='RL_ijmN' || roleid ==='RL_tSU5')) {
                                if (ele['value'] === 'RL_ijmN' || ele['value'] === 'RL_tSU5') {
                                    formData.map((feild, key) => {
                                        if (formData[key]['name'] === 'mapping_unit') {
                                            formData[key]['visible'] = true;
                                            feild['value'] = [];
                                            this.setState((state) => ({ 'formData': formData }), () => { })
                                        }

                                    })
                                } else {
                                    formData.map((feild, key) => {
                                        if (feild['name'] === 'mapping_unit') {
                                            feild['visible'] = false;
                                            feild['value'] = [];
                                        }
                                    })
                                    this.setState((state) => ({ 'formData': formData }), () => { })
                                }

                            }

                            if (ele['value'] === 'RL_UYUR') {
                                formData.map((feild, key) => {
                                    if (formData[key]['name'] === 'nurse_station') {
                                        formData[key]['visible'] = true
                                    }
                                })
                                this.setState((state) => ({ 'formData': formData }), () => { })
                            } else {
                                formData.map((feild, key) => {
                                    if (feild['name'] === 'nurse_station') {
                                        feild['visible'] = false;
                                        feild['value'] = [];
                                    }
                                })
                                this.setState((state) => ({ 'formData': formData }), () => { })
                            }
                            if (ele['value'] === 'RL_aChP'){
                                formData.map((feild, key) => {
                                if (formData[key]['name'] === 'mapping_doctor') {
                                    formData[key]['visible'] = true
                                }
                            })
                            this.setState((state) => ({ 'formData': formData }), () => { })
                            }else{
                                formData.map((feild, key) => {
                                if (formData[key]['name'] === 'mapping_doctor') {
                                    formData[key]['visible'] = false
                                }
                            })
                            this.setState((state) => ({ 'formData': formData }), () => { })
                            }
                            
                           

                        }
                    }
                    this.setState({formData:formData});
                    let This = this;
                    // setTimeout(function () {
                    //     if ((ele['name'] === 'name' && data['name'] === 'name') || (ele['name'] === 'user_id' && data['name'] === 'user_id')) {
                    //         data.visible=true;
                    //     }
                    //     This.setState({formData:formData});
                    // },100)
                    // this.setState({formData:formData});
                    
                });
        }
        if (ele) {
            if (Array.isArray(ele)) {
                privilegeTableSchema.map((subTable, key) => {
                    let table_name = ele[0].feilds[0].table;
                    if (subTable.name === table_name) {
                        let table_body = subTable.Specification.table_body;
                        privilegeTableSchema[key].Specification.table_body = table_body.concat(ele);
                        this.setState({privilegeTableSchema:privilegeTableSchema})
                    }
                })
            }
        }
        

    }

    privilegeGetData() {
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const { getPrivilegesbyid } = networkList
        this.setState((state) => ({ addText: 'Edit Privilege', buttonText: 'Update', 'formData': editPrivilegeSchema['feilds'] }), () => {
            postService(getPrivilegesbyid, 'POST', { 'id': parseInt(rid) }).then(res => {
                if (res.status) {
                    editPrivilegeSchema['feilds'].map((feild, key) => {
                        if (feild['name'] === 'privilege_name') {
                            editPrivilegeSchema['feilds'][key]['value'] = res.data["privileges"][0]['privilege_name'];
                            editPrivilegeSchema['feilds'][key]['disable'] = true;
                        }
                        if (feild['name'] === 'emergency') {

                            if (res.data["privileges"][0]['is_emergency'] == 1) {
                                editPrivilegeSchema['feilds'][key]['value'] = '1';
                                editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                            } else {
                                editPrivilegeSchema['feilds'][key]['value'] = '0';
                                editPrivilegeSchema['feilds'][key]['text'] = 'No';
                            }
                        }
                        if (feild['name'] === 'form_type') {
                            editPrivilegeSchema['feilds'][key]['value'] = res.data["privileges"][0]['form_type_id'];
                            editPrivilegeSchema['feilds'][key]['text'] = res.data["privileges"][0]['form_type_name'];
                        }
                        if (feild['name'] === 'time_duration') {
                            editPrivilegeSchema['feilds'][key]['value'] = res.data["units"][0]['time_duration'];
                            editPrivilegeSchema['feilds'][key]['text'] = res.data["units"][0]['time_duration'];
                        }
                        if (feild['name'] === 'unitname') {
                            this.setState({ units: res.data['units'] })
                            console.log(res.data['units'])
                        }
                        if (feild['name'] === 'admission') {

                            if (res.data["privileges"][0]['only_admission'] == 1) {
                                editPrivilegeSchema['feilds'][key]['value'] = '1';
                                editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                            } else {
                                editPrivilegeSchema['feilds'][key]['value'] = '0';
                                editPrivilegeSchema['feilds'][key]['text'] = 'No';
                            }
                        }
                        if (feild['name'] === 'whatsapp') {

                            if (res.data["privileges"][0]['send_whatsapp_sms'] == 1) {
                                editPrivilegeSchema['feilds'][key]['value'] = '1';
                                editPrivilegeSchema['feilds'][key]['text'] = 'Yes';
                            } else {
                                editPrivilegeSchema['feilds'][key]['value'] = '0';
                                editPrivilegeSchema['feilds'][key]['text'] = 'No';
                            }
                        }
                    })
                    this.setState({ addText: 'Edit Privilege', buttonText: 'Update', 'formData': editPrivilegeSchema['feilds'] });
                    // alert('Data inserted');
                    // console.log('getPrivilegesbyid', res)
                    // this.setState((state) => ({ btnloading: false }));
                }
            })
        });
    }
    

    addUser() {
        let This = this;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        const { createUser, createDoctor, updateUserDetailsById, editDoctor, addCounsellingStation, checkDuplicateUser, updateCounsellingStation,checkDuplicateDoctor } = networkList;
        const { slug } = this.props.match.params;
        var formFeilds = this.state.formData;
        let { privilageSelectID,privilegeTableSchema } = this.state;
        let errors = this.validateModalFeilds(formFeilds);
        let errors1 =this.validateModalFeilds2(privilegeTableSchema);
        
        let validatePrivilages = [];
        let counsellorvalidation='';
        formFeilds.map((sva, key) => {
            if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                counsellorvalidation=sva['value'];
                validatePrivilages = this.validatePrivilages(formFeilds)
                if (privilageSelectID.length !== 0) {
                    errors = errors.concat([true])
                    this.setState((state) => ({ previlages_message_show: false }))
                }
                // if(validatePrivilages.includes(true)){
                //     errors = errors.concat([true])
                //     this.setState((state) => ({ previlages_message_show: false }))
                // }
                else {
                    errors = errors.concat([false])
                    this.setState((state) => ({ previlages_message_show: true }))
                }
            }
            else if (sva['name'] === 'role_id' && sva['value'] !== 'RL_HjPW') {
                counsellorvalidation=sva['value'];
                this.setState((state) => ({ previlages_message_show: false }))
            }
        })
        let role_id = null;
        if (!errors.includes(false) &&  (counsellorvalidation==='RL_HjPW' ? !errors1.includes(false):true) ) {
            this.setState((state) => ({ 'loadding': true }))
            if (slug === 'add-user') {
                var data = {
                    'privileges': [],
                    'dob': null
                }

                formFeilds.map((sva, key) => {
                    data[sva['name']] = sva['value'];
                    if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                        let count = 1;
                        const newAr = privilageSelectID.map(item => {
                            const obj = { id: count, value: item.value }
                            count++;
                            return obj;
                        })

                        data['privileges'] = [].concat(newAr)
                        // data['privileges'].push(privilageSelectID)
                    }
                    if (sva['name'] === 'role_id' && sva['value'] != 'RL_HjPW') {
                        data['privileges'] = [];
                    }

                    if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                        formFeilds.map((sva, key) => {
                            if (sva['name'] === 'payment1') {
                                console.log('value', sva['value']);
                                if (sva['value'].length > 0) {
                                    let temp = [];
                                    if (sva['value'][0]['id'] !== undefined) {
                                        sva['value'].map((types, key) => {
                                            temp.push(types['id']);
                                        })
                                        data['payment1'] = temp;
                                    }
                                    else {
                                        data['payment1'] = sva['value'];
                                    }
                                }
                                else {
                                    data['payment1'] = [];
                                }
                            }
                        })
                    }
                });
                // if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                //     formFeilds.map((feild, Feilskey) => {
                //         if (feild['id'] > 11 && feild['element'] === 'checkbox' && feild['value'] !== null && feild['value']) {
                //             data['privileges'].push(feild['name'])
                //         }
                //     })
                // }
                // if (sva['name'] === 'role_id' && sva['value'] != 'RL_HjPW') {
                //     data['privileges'] = [];
                // }

                // });
                formFeilds.map((sva, key) => {
                    let user_data = JSON.parse(localStorage.getItem('user_data'));
                    const roleid = user_data ? user_data.roleid : '';
                    if (sva['name'] === 'role_id') {
                        if(roleid === "RL_ayhy" ||  (roleid === "RL_ijmN" || roleid === 'RL_tSU5')){
                            formFeilds.map((sva, key) => {
                                if (sva['name'] === 'mapping_unit') {
                                    console.log('value', sva['value']);
                                    if (sva['value'] !== null) {
                                        if (sva['value'].length > 0) {
                                            let temp = [];
                                            if (sva['value'][0]['id'] !== undefined) {
                                                sva['value'].map((types, key) => {
                                                    temp.push(types['id']);
                                                })
                                                data['mapping_unit'] = temp;
                                            }
                                            else {
                                                let unit = [];
                                                sva['value'].map(item => {
                                                    let obj = { id: item }
                                                    unit.push(obj);
                                                })
                                                data['mapping_unit'] = [].concat(unit)
                                            }
                                        }
                                        else {
                                            data['mapping_unit'] = [];
                                        }
                                    } else {
                                        data['mapping_unit'] = [];
                                    }
    
                                }
                            })
                        }else{
                            data['mapping_unit'] = [];
                        }
                        

                    }
                    if (sva['name'] === 'role_id') {
                        if(roleid === "RL_ijmN" || roleid === 'RL_tSU5'){
                            formFeilds.map((sva, key) => {
                                if (sva['name'] === 'mapping_conselling_station') {
                                    console.log('value', sva['value']);
                                    if (sva['value'] !== null) {
                                        if (sva['value'].length > 0) {
                                            let temp = [];
                                            if (sva['value'][0]['id'] !== undefined) {
                                                sva['value'].map((types, key) => {
                                                    temp.push(types['id']);
                                                })
                                                data['mapping_conselling_station'] = temp;
                                            }
                                            else {
                                                let unit = [];
                                                sva['value'].map(item => {
                                                    let obj = { id: item }
                                                    unit.push(obj);
                                                })
                                                data['mapping_conselling_station'] = [].concat(unit)
                                            }
                                        }
                                        else {
                                            data['mapping_conselling_station'] = [];
                                        }
                                    } else {
                                        data['mapping_conselling_station'] = [];
                                    }
    
                                }
                            })
                        }else{
                            data['mapping_conselling_station'] = [];
                        }
                        

                    }
                    // if (sva['name'] === 'role_id') {
                    //     if(sva['value'] === "RL_aChP"){
                    //         formFeilds.map((sva, key) => {
                    //             if (sva['name'] === 'mapping_doctor') {
                    //                 console.log('value', sva['value']);
                    //                 if (sva['value'] !== null) {
                    //                     if (sva['value'].length > 0) {
                    //                         let temp = [];
                    //                         if (sva['value'][0]['id'] !== undefined) {
                    //                             sva['value'].map((types, key) => {
                    //                                 temp.push(types['id']);
                    //                             })
                    //                             data['mapping_doctor'] = temp;
                    //                         }
                    //                         else {
                    //                             let unit = [];
                    //                             sva['value'].map(item => {
                    //                                 let obj = { id: item }
                    //                                 unit.push(obj);
                    //                             })
                    //                             data['mapping_doctor'] = [].concat(unit)
                    //                         }
                    //                     }
                    //                     else {
                    //                         data['mapping_doctor'] = [];
                    //                     }
                    //                 } else {
                    //                     data['mapping_doctor'] = [];
                    //                 }
    
                    //             }
                    //         })
                    //     }else{
                    //         data['mapping_doctor'] = [];
                    //     }
                        

                    // }
                    // if (roleid === "RL_ijmN" ) {
                    //     if(data['mapping_conselling_station'].length===0){
                    //         data['mapping_conselling_station'] =data['mapping_conselling_station'].push({id:data['counselling_stations']});  
                    //     }
                    //     else{
                    //        let duplicateArraya= data['mapping_conselling_station'].filter((item)=>{
                    //         debugger
                    //             return item.id===data['counselling_stations']
                    //         })
                    //         if(duplicateArraya.length===0){
                    //             debugger
                    //             data['mapping_conselling_station'].push({id:data['counselling_stations']}); 
                    //         }
                    //     }
                    // }
                });
                console.clear();
                console.log('data',data);
                if (data.user_id !== null && data.user_id !== '') {
                    try {
                        postService(checkDuplicateUser, 'POST', { "username": data.user_id }).then(res => {
                            if (res.data === '0') {
                                postService(createUser, 'POST', { "data": data }).then(res => {
                                    if (res.status) {
                                        this.setState((state) => ({ 'loadding': false }))
                                        Modal.success({
                                            title: 'Success message',
                                            content: 'User Added Successfully',
                                            onOk: function () {
                                                This
                                                    .props
                                                    .history
                                                    .push('/settings/users');
                                            }
                                        });
                                    } else {
                                        this.setState((state) => ({ 'loadding': false }))
                                        Modal.error({
                                            title: 'Error message',
                                            content: 'Something went wrong. Please,try again later',
                                            onOk: function () {
                                                window.scrollTo(0, 0);
                                            }
                                        });

                                    }
                                })
                            } else {
                                // formData[key]['value'] = null;
                                // formData[key]['disable'] = true;
                                // formData[key]['errors'].push({ 'message': 'User Id Already exists' });
                                this.setState((state) => ({ 'loadding': false }))
                                Modal.info({
                                    title: 'Info message',
                                    content: 'User Id Already exists'
                                });
                            }

                        })
                    } catch (error) {
                        console.log(error);
                        Modal.error({
                            title: 'Failure',
                            content: "Oops, something went wrong... Please try again.",
                        });
                    }
                }
            }

            if (slug === 'edit-user') {
                var data = {
                    'id': rid ? rid : null,
                    'status': 1,
                    'dob': null,
                    'privileges': []
                }
                let role_id_temp = '';
                formFeilds.map((sva, key) => {
                    data[sva['name']] = sva['value'];
                    if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                        let count = 1;
                        const newAr = privilageSelectID.map(item => {
                            const obj = { id: count, value: item.value }
                            count++;
                            return obj;
                        })

                        data['privileges'] = [].concat(newAr)
                        role_id_temp = sva['value'];
                        // formFeilds.map((feild, Feilskey) => {
                        //     if (feild['id'] > 9 && feild['element'] === 'checkbox' && feild['value'] !== null && feild['value']) {
                        //         data['privileges'].push(feild['name'])
                        //     }
                        // })
                    }
                    if (sva['name'] === 'phonenumber') {
                        data['phone_number'] = sva['value'];
                    }
                    if (sva['name'] === 'role_id' && sva['value'] != 'RL_HjPW') {
                        data['privileges'] = [];
                    }

                    // if (sva['name'] === 'counsellor_type') {
                    //     if(sva['value'].length>0){
                    //         let temp = [];
                    //         if(sva['value'][0]['id'] !== undefined ){
                    //             sva['value'].map((types, key) => {
                    //                 temp.push(types['id']);
                    //             })
                    //             data['counsellor_type'] = temp;
                    //         }
                    //         else{
                    //             data['counsellor_type'] = sva['value'];
                    //         }
                    //     }
                    //     else{
                    //         data['counsellor_type'] = [];
                    //     }
                    // }
                });

                if (role_id_temp === 'RL_HjPW') {
                    formFeilds.map((sva, key) => {
                        if (sva['name'] === 'counsellor_type') {
                            if (sva['value']&&sva['value'].length > 0) {
                                let temp = [];
                                if (sva['value'][0]['id'] !== undefined) {
                                    sva['value'].map((types, key) => {
                                        temp.push(types['id']);
                                    })
                                    data['counsellor_type'] = temp;
                                }
                                else {
                                    data['counsellor_type'] = sva['value'];
                                }
                            }
                            else {
                                data['counsellor_type'] = [];
                            }
                        }
                    })
                }
                else {
                    data['counsellor_type'] = [];
                }
                formFeilds.map((sva, key) => {
                    let user_data = JSON.parse(localStorage.getItem('user_data'));
                    const roleid = user_data ? user_data.roleid : '';
                    if (sva['name'] === 'role_id') {
                        if(roleid === "RL_ayhy" ||  (roleid === "RL_ijmN" || roleid === 'RL_tSU5')){
                            formFeilds.map((sva, key) => {
                                if (sva['name'] === 'mapping_unit') {
                                    console.log('value', sva['value']);
                                    if (sva['value'] !== null) {
                                        if (sva['value'].length > 0) {
                                            let temp = [];
                                            if (sva['value'][0]['id'] !== undefined) {
    
                                                // sva['value'].map((types, key) => {
                                                //     temp.push(types['id']);
                                                // })
                                                data['mapping_unit'] = sva['value'];
                                            }
                                            else {
                                                const newAr = sva['value'].map(item => {
                                                    let obj = { 'id': item }
                                                    return obj;
                                                })
                                                data['mapping_unit'] = [].concat(newAr);
                                            }
                                        }
                                        else {
                                            data['mapping_unit'] = [];
                                        }
                                    } else {
                                        data['mapping_unit'] = [];
                                    }
    
                                }
                            })
                        }else{
                            data['mapping_unit'] = [];
                        }
                        

                    }
                    if (sva['name'] === 'role_id') {
                        if(roleid === "RL_ijmN" || roleid === 'RL_tSU5'){
                            formFeilds.map((sva, key) => {
                                if (sva['name'] === 'mapping_conselling_station') {
                                    console.log('value', sva['value']);
                                    if (sva['value'] !== null) {
                                        if (sva['value'].length > 0) {
                                            let temp = [];
                                            if (sva['value'][0]['id'] !== undefined) {
    
                                                // sva['value'].map((types, key) => {
                                                //     temp.push(types['id']);
                                                // })
                                                data['mapping_conselling_station'] = sva['value'];
                                            }
                                            else {
                                                const newAr = sva['value'].map(item => {
                                                    let obj = { 'id': item }
                                                    return obj;
                                                })
                                                data['mapping_conselling_station'] = [].concat(newAr);
                                            }
                                        }
                                        else {
                                            data['mapping_conselling_station'] = [];
                                        }
                                    } else {
                                        data['mapping_conselling_station'] = [];
                                    }
    
                                }
                            })
                        }else{
                            data['mapping_conselling_station'] = [];
                        }
                        

                    }
                    // if (sva['name'] === 'role_id') {
                    //     if(sva['value'] === "RL_aChP"){
                    //         formFeilds.map((sva, key) => {
                    //             if (sva['name'] === 'mapping_doctor') {
                    //                 console.log('value', sva['value']);
                    //                 if (sva['value'] !== null) {
                    //                     if (sva['value'].length > 0) {
                    //                         let temp = [];
                    //                         if (sva['value'][0]['id'] !== undefined) {
                    //                             sva['value'].map((types, key) => {
                    //                                 temp.push(types['id']);
                    //                             })
                    //                             data['mapping_doctor'] = temp;
                    //                         }
                    //                         else {
                    //                             let unit = [];
                    //                             sva['value'].map(item => {
                    //                                 let obj = { id: item }
                    //                                 unit.push(obj);
                    //                             })
                    //                             data['mapping_doctor'] = [].concat(unit)
                    //                         }
                    //                     }
                    //                     else {
                    //                         data['mapping_doctor'] = [];
                    //                     }
                    //                 } else {
                    //                     data['mapping_doctor'] = [];
                    //                 }
    
                    //             }
                    //         })
                    //     }else{
                    //         data['mapping_doctor'] = [];
                    //     }
                        

                    // }
                });
                

                console.clear();
                console.log(data);
                postService(updateUserDetailsById, 'POST', { "data": data }).then(res => {
                    if (res.status) {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.success({
                            title: 'Success message',
                            content: 'User updated Successfully',
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push('/settings/users');
                            }
                        });


                    } else {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.error({
                            title: 'Error message',
                            content: 'Something went wrong. Please,try again later',
                            onOk: function () {
                                window.scrollTo(0, 0);
                            }
                        });
                    }
                })
            }

            if (slug === 'add-doctor') {
                var data = {}

                formFeilds.map((sva, key) => {
                    data[sva['name']] = sva['value'];
                    if(sva['name']==='department_id'){
                        data[sva['name']] = sva['text'];
                    }
                    if (sva['name'] === 'phonenumber') {
                        data['phone_number'] = sva['value'];
                    }

                });
                console.clear();
                console.log(data);
                postService(checkDuplicateDoctor, 'POST', { "data": data }).then(res => {
                    if (res.data === '0') {
                postService(createDoctor, 'POST', { "data": data }).then(res => {
                    if (res.status) {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.success({
                            title: 'Success message',
                            content: res.message?res.message:'Doctor Added Successfully',
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push('/settings/doctors');
                            }
                        });


                    } else {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.error({
                            title: 'Error message',
                            content: 'Something went wrong. Please,try again later',
                            onOk: function () {
                                window.scrollTo(0, 0);
                            }
                        });
                    }
                })
            }else{
                this.setState((state) => ({ 'loadding': false }))
                Modal.info({
                    title: 'Info message',
                    content: 'Doctor Id Already exists'
                });
            }
        })
            }

            if (slug === 'edit-doctor') {
                var data = {
                    'id': rid ? rid : null,
                    'status': 1,
                    'privileges': []
                }

                formFeilds.map((sva, key) => {
                    data[sva['name']] = sva['value'];
                    if (sva['name'] === 'role_id' && sva['value'] === 'RL_HjPW') {
                        formFeilds.map((feild, Feilskey) => {
                            if (feild['id'] > 9 && feild['element'] === 'checkbox' && feild['value'] !== null && feild['value']) {
                                data['privileges'].push(feild['name'])
                            }
                        })
                    }
                    if (sva['name'] === 'phonenumber') {
                        data['phone_number'] = sva['value'];
                    }
                    if (sva['name'] === 'role_id' && sva['value'] != 'RL_HjPW') {
                        data['privileges'] = [];
                    }

                    if (sva['name'] === 'counsellor_id') {
                        let newData = [];
                        sva['value'].map((userData, roomKey) => {
                            if (userData['counsellor_id']) {
                                let id = userData['counsellor_id']
                                newData.push({
                                    'doctor_id': data.id,
                                    'counsellor_id': id
                                })
                            } else {
                                newData.push({
                                    'doctor_id': data.id,
                                    'counsellor_id': userData
                                })
                            }
                        })
                        data['counsellors'] = newData;
                    }

                });
                console.clear();
                console.log(data);
                postService(editDoctor, 'POST', { "data": data }).then(res => {
                    if (res.status) {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.success({
                            title: 'Success message',
                            content: 'Doctor Updated Successfully',
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push('/settings/doctors');
                            }
                        });
                    } else {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.error({
                            title: 'Error message',
                            content: 'Something went wrong. Please,try again later',
                            onOk: function () {
                                window.scrollTo(0, 0);
                            }
                        });
                    }
                })
            }

            if (slug === 'add-counselling-stations') {
                var data = {}
                formFeilds.map((sva, key) => {
                    if (sva['name'] === 'counselling_station_name') {
                        data['counselling_station_name'] = sva['value'];
                    }
                    if (sva['name'] === 'unit_id') {
                        data['unit_id'] = sva['value'];
                    }
                    if (sva['name'] === 'cabin_count') {
                        data['cabin_count'] = parseInt(sva['value']);
                    }
                });
                const Userlogobj = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Create Counselling Station - Request",
                        "date": new Date(),
                        "meta": data
                    }
                }
                userTrackService(Userlogobj);

                postService(addCounsellingStation, 'POST', data).then(res => {
                    const Userlogobjres = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Create Counselling Station - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    userTrackService(Userlogobjres);
                    console.log(res.status)
                    if (res.status) {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.success({
                            title: 'Success message',
                            content: res.message ? res.message : 'New Counselling Station Added Successfully',
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push('/settings/counselling-stations');
                            }
                        });


                    } else {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.error({
                            title: 'Error message',
                            content: res.message ? res.message:'Something went wrong. Please,try again later',
                            onOk: function () {
                                window.scrollTo(0, 0);
                            }
                        });

                    }
                })
            }

            if (slug === 'edit-counselling-stations') {
                var data = {
                    'id': parseInt(rid) ? parseInt(rid) : null,
                    'counselling_station_name': ''
                }
                formFeilds.map((sva, key) => {
                    if (sva['name'] === 'counselling_station_name') {
                        data['counselling_station_name'] = sva['value'];
                    }
                    if (sva['name'] === 'cabin_count') {
                        data['cabin_count'] = sva['value'];
                    }
                });
                const Userlogobj = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Update Counselling Station - Request",
                        "date": new Date(),
                        "meta": data
                    }
                }
                userTrackService(Userlogobj);
                postService(updateCounsellingStation, 'POST', data).then(res => {
                    const Userlogobjres = {
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Update Counselling Station - Response",
                            "date": new Date(),
                            "meta": res
                        }
                    }
                    userTrackService(Userlogobjres);
                    if (res.status) {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.success({
                            title: 'Success message',
                            content: res.message,
                            onOk: function () {
                                This
                                    .props
                                    .history
                                    .push('/settings/counselling-stations');
                            }
                        });


                    } else {
                        this.setState((state) => ({ 'loadding': false }))
                        Modal.error({
                            title: 'Error message',
                            content: res.message,
                            onOk: function () {
                                window.scrollTo(0, 0);
                            }
                        });
                    }
                })
            }
            if (slug === 'edit-privilege') {
                const { editPrivilegesbyid } = networkList;
                let {allUnitPriviage,previesUnitPriviegeTime}=this.state

                // const filterOptions = previesUnitPriviegeTime.filter(item => {
                //     return !allUnitPriviage.some(id => id.id === item.id)
                // })
                // console.log(filterOptions);
                // return false
                const user = JSON.parse(Storage.get('user'));

                // console.log(this.state)
                if(allUnitPriviage.length>0){
                let data = {
                    'id': rid ? rid : null,
                    'is_emergency': formFeilds[1].value,
                    'form_type_id': formFeilds[2].value,
                    'only_admission': formFeilds[3].value,
                    'allUnitPriviage':allUnitPriviage,
                }
                console.log('FormFeilds', formFeilds);
                var name = formFeilds[0].value
                var emergency = parseInt(formFeilds[1].value)
                var form_type_id = parseInt(formFeilds[2].value);
                var admission = parseInt(formFeilds[5].value);
                var whatsapp = parseInt(formFeilds[6].value);
                // var time_duration=formFeilds[3].value;
                // console.clear();
                // console.log('addprivilege data:', data)
                const Userlogobj = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Update Privileges - Request",
                        "date": new Date(),
                        "meta": {
                            'id': parseInt(rid),
                            'is_emergency': emergency,
                            'form_type_id': form_type_id,
                            'only_admission' : admission,
                            'send_whatsapp_sms': whatsapp,
                        }
                    }
                }
                userTrackService(Userlogobj);
                this.setState((state) => ({ thead: this.state.tableHead, btnloading: true }), () => {
                    postService(editPrivilegesbyid, 'PUT', {
                        'id': parseInt(rid),
                        'is_emergency': emergency,
                        'form_type_id': form_type_id,
                        'allUnitPriviage':allUnitPriviage,
                        'only_admission' : admission,
                        'send_whatsapp_sms': whatsapp,
                    }).then(res => {
                        const Userlogobjres = {
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Update Privileges - Response",
                                "date": new Date(),
                                "meta": res
                            }
                        }
                        userTrackService(Userlogobjres);
                        if (res.status) {
                            // alert('Data inserted');
                            // console.log('res', res)
                            this.setState((state) => ({ btnloading: false, visible: false,priviageErrorMessage:false }));
                            this.privilegeGetData();
                            Modal.success({
                                title: 'Success',
                                content: `${res.message}`,
                                onOk: function () {
                                    This
                                        .props
                                        .history
                                        .push('/settings/privileges');
                                }
                            });
                        } else {
                            // alert('Data not inserted');
                            Modal.error({
                                title: 'Failure',
                                content: `${res.message}`,
                                onOk: function () {
                                    window.scrollTo(0, 0);
                                }
                            });
                        }
                    })
                });
            }else{
                this.setState({priviageErrorMessage:true,loadding:false});
            }

            }
        }
    }

    cancel() {
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
        let { slug } = this.props.match.params;
        switch (slug) {
            case 'add-user':
            case 'edit-user':
                this
                    .props
                    .history
                    .push('/settings/users');
                break;
            case 'add-doctor':
            case 'edit-doctor':
                this
                    .props
                    .history
                    .push('/settings/doctors');
                break;
            case 'add-counselling-stations':
            case 'edit-counselling-stations':
                this
                    .props
                    .history
                    .push('/settings/counselling-stations');
                break;
            case 'edit-privilege':
                this
                    .props
                    .history
                    .push('/settings/privileges');
                break;
            default:
                break;
        }
    }


    validateModalFeilds(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if (feild['element'] === 'input' || feild['element'] === 'select2'|| feild['element'] === 'select2multiple' || feild['element'] === 'date') {
                if (feild['name'] === 'role_id' && feild['value'] === 'RL_HjPW') {
                    role_id = true;
                } else {
                    role_id = false;
                }
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible && feild.required) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if (rule.test !== undefined && typeof rule.test === 'function' && !rule.test(feild['value'])) {
                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                        })
                        // if(feild.name==="name"&& feild.value!==null ){
                        //     var    regex = /^[a-zA-Z ]*$/
                        //     if(regex.test(feild.value)){
                               
                        //     }else{
                        //         formFeilds[key]['errors'].push({ 'message': 'Please enter alphabets only' });
                        //         errors.push(false);
                        //     }
                        // }
                        // if(feild.name==="user_id" && feild.value!==null){
                        //     var   regexs = /^[0-9]*$/
                        //     if(regexs.test(feild.value)){
                               
                        //     }else{
                        //         formFeilds[key]['errors'].push({ 'message': 'Please enter numbers only' });
                        //         errors.push(false);
                        //     }
                        // }

                }
            }
            if (role_id !== null && role_id) {

            }
        })

        this.setState((state) => ({ formData: formFeilds }));
        return errors;
    }
    validateModalFeilds2(formFeilds) {
        let errors = [];
        let role_id = null;
        formFeilds.map((subTable, key) => {
            if (subTable.title) {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    let feildss = feild.feilds;
                    feildss.map((feild, fkey) => {
                        if ((feild['element'] === 'input' || feild['element'] === 'select') || feild['element'] === 'radio') {
                            formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                            if (!feild.disable && feild.visible) {
                                feild.rules.map((rule, rkey) => {
                                    if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined) || (feild['value'] === 0)) {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'].push({ 'message': rule.message });
                                        errors.push(false);
                                    }
                                    else {
                                        formFeilds[key].Specification.table_body[table_key].feilds[fkey]['errors'] = [];
                                        errors.push(true);
                                    }
                                })
                            }
                        }
                    })
                })
            }
        })
        console.log('error', formFeilds)
        this.setState((state) => ({ drugsSchema: formFeilds }));
        return errors;
    }
    validatePrivilages(formFeilds) {
        let validatePrivilages = [];
        formFeilds.map((feild, key) => {
            if (feild['element'] === 'checkbox') {
                if (feild['value'] === true) {
                    validatePrivilages.push(true)
                }
                else {
                    validatePrivilages.push(false)
                }
            }
        })

        return validatePrivilages;
    }
    
    switchChange(status, id, index) {
        const { disableprivilegebyid } = networkList;
        if (status == true) {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Change status for Privilege - Request",
                    "date": new Date(),
                    "meta": {
                        "id": id
                    }
                }
            }
            userTrackService(Userlogobj);
            postService(disableprivilegebyid, 'POST', {
                'data': {
                    'id': id,
                    'status': 1,
                    'updated_at': this.state.date
                }
            }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Change status for Privilege - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res.status) {
                    // alert('Data inserted');
                    this.privilegeGetData();
                    Modal.success({
                        title: 'success',
                        content: "Your changes has been updated.",
                    });
                } else {
                    // alert('Data not inserted');
                    Modal.error({
                        title: 'Failure',
                        content: "Oops, something went wrong... Please try again.",
                    });
                }
            })
        } else {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Change status for Privilege - Request",
                    "date": new Date(),
                    "meta": {
                        "id": id
                    }
                }
            }
            userTrackService(Userlogobj);
            postService(disableprivilegebyid, 'POST', {
                'data': {
                    'id': id,
                    'status': 0,
                    'updated_at': this.state.date
                }
            }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Change status for Privilege - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res.status) {
                    // alert('Data inserted');
                    this.privilegeGetData();
                    Modal.success({
                        title: 'success',
                        content: "Your changes has been updated.",
                    });
                } else {
                    // alert('Data not inserted');
                    Modal.error({
                        title: 'Failure',
                        content: "Oops, something went wrong... Please try again.",
                    });
                }
            })

        }
    }

    deleteRow(row_id) {
        let { privilageSelectID,privilegeTableSchema } = this.state;
        const filterIds = privilageSelectID.filter(item => item.id !== row_id[0]['id'])
        // const newAr = filterIds.map(item => {
        //     const obj = { id: count, value: item.value }
        //     count++;
        //     return obj;
        // })
        privilegeTableSchema.map((subTable, key) => {
                let table_body = subTable.Specification.table_body;
                table_body.map((feild, table_key) => {
                    if (feild.id === row_id[0]['id']) {
                        privilegeTableSchema[key].Specification.table_body.splice(table_key, 1);
                    }
                })
        })
        this.setState({ privilageSelectID: filterIds,privilegeTableSchema });
    }
    processChange = (data,event) => {
        let {allUnitPriviage}=this.state
        if(event.target.value!==0 && event.target.value!=='0' && event.target.value!==null){
            data.time_duration=parseInt(event.target.value);
            if(allUnitPriviage.length==0){
                allUnitPriviage.push(data);  
            }else{
                const index = allUnitPriviage.map(item => item.id).indexOf(data.id);
                if (index > -1) {
                    allUnitPriviage[index].time_duration =parseInt(event.target.value);
                } else {
                    allUnitPriviage.push(data)
                }
                
            }
            this.setState({allUnitPriviage})
        }
        
    }

    render() {
        let { showPrevilages, formData, addText, units, buttonText, previlages_message_show, privilegeTableSchema,thead,tbody,priviageErrorMessage } = this.state;
        let { slug } = this.props.match.params
        console.log(formData);
        return (
            <div>
                <Spin spinning={this.state.loadding}>
                    <div className="card pt-5 pb-5 m-5">
                        <h1 className="text-center text-capitalize text-heading mb-0">{addText}</h1>
                        <div className={`row pt-4 pl-5 pr-5 ${slug === 'add-counselling-stations' || slug === 'edit-counselling-stations' ? 'justify-content-center' : 'align-items-end'}`}>
                            {/* <div className="row pt-4 pl-5 pr-5  align-items-end"> */}
                            {(formData !== undefined) && <React.Fragment>

                                {formData
                                    .map((feild, key) => {

                                        if (feild.element === 'input' && feild.visible) {
                                            return (

                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col'} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <div className="clearfix">
                                                        <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                    </div>
                                                    <Inputlayer
                                                        {...this.props}
                                                        {...this.state}
                                                        feildData={feild}
                                                        onInputChanges={this
                                                            .handleChange
                                                            .bind(this)}

                                                    />

                                                </div>

                                            )
                                        }

                                        if (feild.element === 'text' && feild.visible) {
                                            return (
                                                <React.Fragment>
                                                    <div className="col-xl-3 col-lg-3 col-sm-5 clearfix">
                                                        <p className="data-label w-100 mb-1 pt-2">Unit Name</p>
                                                        {
                                                            units.map((data, key) => {
                                                                return (<p>{data.unitname}</p>)
                                                            })
                                                        }
                                                    </div>
                                                    <div className="col-xl-1 col-lg-1 col-sm-3 clearfix">
                                                        <p className="data-label w-100 mb-1 pt-2">Status</p>
                                                        {
                                                            units.map((data, key) => {
                                                                return (
                                                                    <div className="row privilege_updtae_margin_bottom mb-3">
                                                                        <div className="col-4">
                                                                            <Switch checked={parseInt(data.status)} onChange={(status) => this.switchChange(status, data.id, key)} />
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                    <div className="col-xl-4 col-lg-4 col-sm-3 clearfix">
                                                        <p className="data-label w-100 mb-1 pt-2">Default Time Duration(minutes)</p>
                                                        {
                                                            units.map((data, key) => {
                                                                return (
                                                                            <div className='mb-2'>
   <input 
                                autoComplete="off"
                                 ref={(inputRef =>(this.inputRef = inputRef))}
                                 
                                 type='number'
                                 className="ant-input" 
                                 id='time_duration' 
                                 placeholder='Enter Default Time Duration'
                                 defaultValue={data.time_duration==0?null:data.time_duration}
                                 onKeyUp={this.processChange.bind(this,data)}
                                //  onChange={this.handleKeyPress}
                                //   onBlur={this.handleKeyPress}
                                  />
                                  {priviageErrorMessage&&<small  className="form-text text-danger">Please Enter Default Time Duration</small>}
                                    
                                                                                        
                                                                            </div>          
                                                                                      
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }

                                        if (feild.element === 'select2' && feild.visible) {
                                            return (
                                                <React.Fragment key={key}>
                                                    {(feild.name === 'patient_list' && feild.disable === false) &&
                                                        <div className="col-6">
                                                            <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                        </div>}
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} my-2 ${feild.name}`}
                                                        key={key}>
                                                        <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                        <Select2
                                                            selectdata={feild}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this
                                                                .handleChange
                                                                .bind(this)} /> {feild
                                                                    .errors
                                                                    .map((error, eKey) => {
                                                                        return (
                                                                            <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                        );
                                                                    })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                        if (feild.element === 'select2multiple' && feild.visible) {
                                            return (
                                                <React.Fragment key={key}>

                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} my-2 ${feild.name}`}
                                                        key={key}>
                                                        <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                        <Select2multiple
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={this
                                                                .handleChange
                                                                .bind(this, feild)}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                        if (feild.element === 'date' && feild.visible) {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col '} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <p className="data-label w-100 mb-1 pt-2">{feild.title}</p>
                                                    <Datepicker
                                                        // Queuedata={filtereData}
                                                        selectdata={feild}
                                                        {...this.props}
                                                        {...this.state}
                                                        onselectChanges={this
                                                            .handleChange
                                                            .bind(this)}
                                                    // onselectChanges={this
                                                    //     .onChange
                                                    //     .bind(this)} 
                                                    />
                                                    {feild
                                                        .errors
                                                        .map((error, eKey) => {
                                                            return (
                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                            );
                                                        })}
                                                </div>
                                            )

                                        }
                                    })}
                            </React.Fragment>}
                           </div>
                          
                            {tbody.length>0&&(<div className='row pt-3 pl-5 pr-5 mr-1 ml-1'>
                            <h4 class=" w-100 doctormaping">Doctors</h4>
                             <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0">
                                <thead>
                                    <tr>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize" key={key}>{head['text']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                {tbody&& tbody.map((body, key) => {
                                        return (<tr key={key}>

                                            {thead.map((head, Hkey) => {
                                                if (head['key'] === 's_no') {
                                                    return (<td>{key + 1}</td>)
                                                }
                                                return (
                                                    <td className="text-capitalize">{(body[head['key']] !== null) ? body[head['key']] : '--'}</td>
                                                )

                                            })
                                            }

                                        </tr>)
                                    })}
                                
                                {(tbody && tbody.length === 0) && <React.Fragment>
                                    <tr>
                                       <td colSpan={thead.length+1} className="text-center">
                                          <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                          <p className="no-data mb-0">No Data</p>
                                       </td>
                                      </tr> 
                                                    </React.Fragment>}  
                                </tbody>
                            </table>
                        </div>
                        </div>)}
                            <div className='row pt-3 pl-5 pr-5 mr-1 ml-1'>
                            {privilegeTableSchema.map((feild, key) => {
                                if (feild.visible) {
                                    return (<React.Fragment key={key}>
                                        <div className="d-inline-flex w-100">
                                            <h4 className="data-label w-100" style={{ fontSize: 20 }}>{feild.title}</h4>
                                        </div>
                                        <div className="financial-table table-responsive">
                                            <Tableantd form_table={'previlage'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />
                                        </div>
                                    </React.Fragment>)
                                }
                            })}
                        </div>
                       
                        {(showPrevilages) &&
                            <div className="row pl-5 pr-5 align-items-end">

                                {formData
                                    .map((feild, key) => {


                                        if (feild.element === 'checkbox') {
                                            return (
                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col'} my-2 ${feild.name}`}
                                                    key={key}>
                                                    <input type="checkbox" name={feild.id} value={feild.value} checked={feild.value} onChange={(e) => this
                                                        .handleChange
                                                        ({ 'name': feild.name, 'value': feild.value ? false : true })} /> <label for={feild.text} className="data-label w-75">  {feild.text}</label>
                                                </div>

                                            )
                                        }


                                    })}
                            </div>
                        }
                        <div className="row justify-content-center mt-4">
                            <button className="btn btn-success text-capitalize mr-3" onClick={this.addUser.bind(this)}>{buttonText}</button>
                            <button className="btn btn-success btn-next text-capitalize" onClick={this.cancel.bind(this)}>cancel</button>
                        </div>
                    </div>
                </Spin>
            </div>
        )

    }
}
export default Add_User;